export const notifications = {
  notifications: {
    prompt: {
      title: "Recibe notificaciones importantes",
      description:
        "Activa las notificaciones para recibir alertas sobre promociones especiales, resultados de juegos y novedades.",
      error: "Ocurrió un error al activar las notificaciones",
      later: "Más tarde",
      enable: "Activar notificaciones",
      activating: "Activando...",
    },
  },
};
